import * as React from 'react'
import { H1 } from '@berlitz/globals'
import Spacer from '@berlitz/spacer'
import moment from 'moment'
import get from 'lodash/get'
import { injectIntl, InjectedIntlProps, FormattedMessage } from 'react-intl'
import { getQueryParams } from '@utils/helpers'
import { withApollo, WithApolloClient } from 'react-apollo'
import { GET_USER_PROFILE } from '@queries/userProfile'
import { GET_DECRYPTS } from '@queries/decrypt'
import { UserProfileProps } from '@interfaces/UserProfile'

import Error from '@components/Error'
import InstructorScheduler from '@components/InstructorScheduler'
import { getTitle } from '@components/InstructorScheduler/util'
import QueryPageData from '@layouts/Availability/QueryPageData'
import { fetchProfileSuccess } from '@redux/actions/userProfile'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PortalInstructor from '@classes/Instructor'
import { IPQueryPageData } from '@layouts/Availability/QueryPageData'
import FetchFail from '@layouts/Availability/FetchFail'
import PortalInstructorAvailabilities from '@classes/InstructorAvailabilities'
import PortalInstructorUnAvailabilities from '@classes/InstructorUnAvailabilities'
import PortalAvailabilityCalendar from '@classes/AvailabilityCalendar'

type Props = WithApolloClient<{ updateUserProfile: Function } & InjectedIntlProps>

class InstructorAvailability extends React.Component<Props> {
  _isMounted = false
  userProfileCtrl = new AbortController()
  decryptCtrl = new AbortController()

  state = {
    pageLoading: false as boolean,
    pageError: false as boolean,
    modalWarningOpen: true as boolean,
    instructorId: '' as string,
    Type: 'Face to face' as string,
    profile: {
      Timezone: moment.tz.guess(),
    } as UserProfileProps,
  }

  async componentDidMount() {
    this._isMounted = true
    const { client } = this.props

    this.setState({
      pageLoading: true,
    })

    try {
      const instructorEmail: string = getQueryParams('ie') || ''
      let Id = decodeURIComponent((localStorage.getItem('_sfid') || '').replace('aai=', ''))

      if (instructorEmail || Id) {
        if (instructorEmail) {
          const res = await client.query({
            query: GET_DECRYPTS,
            variables: {
              encrypts: [instructorEmail.split('%20').join('+').split(' ').join('+')],
            },
            fetchPolicy: 'network-only',
            context: {
              fetchOptions: {
                signal: this.decryptCtrl.signal,
              },
            },
          })
          Id = get(res, 'data.decrypt.decrypts[0]', '')
        }

        const { data } = await client.query({
          query: GET_USER_PROFILE,
          variables: { Type: 'Instructor', Id },
          fetchPolicy: 'network-only',
          context: {
            fetchOptions: {
              signal: this.userProfileCtrl.signal,
            },
          },
        })

        const profile = { ...data.getUserProfile }

        this.setState({
          pageLoading: false,
          profile: profile,
          modalWarningOpen: false,
        })
        this.props.updateUserProfile(profile)
      } else {
        throw 'no email params'
      }
    } catch (error) {
      this.setState({
        pageLoading: false,
        pageError: true,
        modalWarningOpen: true,
      })
    }
  }

  filterEvents = (schedule) =>
    schedule.filter(
      ({ AvailabilityType }) =>
        getTitle(AvailabilityType) !== (this.state.Type === 'Face to face' ? 'Online' : 'Face to face')
    )

  getUserDate = (): moment.Moment => moment.tz(this.state?.profile?.Timezone || moment.tz.guess())

  render() {
    const {
      pageLoading,
      // Type,
      profile,
    } = this.state
    const Instructor = new PortalInstructor(profile.InstructorProfile?.instructorInfo)

    if (!pageLoading && profile && !profile.SFId) {
      return <Error statusCode={404} />
    }

    return (
      <>
        <H1>
          <FormattedMessage id="Instructor Calendar" />
        </H1>

        {pageLoading && (
          <InstructorScheduler
            loading
            Instructor={Instructor}
            AvailabilityCalendar={
              new PortalAvailabilityCalendar(
                new PortalInstructorAvailabilities([], Instructor),
                new PortalInstructorUnAvailabilities([], Instructor),
                Instructor,
                Instructor.CurrentDate,
                true
              )
            }
            refetch={() => {}}
          />
        )}

        {profile && profile.SFId && (
          <QueryPageData profile={profile}>
            {({ loading, error, Availabilities, UnAvailabilities, refetch }: IPQueryPageData) => {
              const AvailabilityCalendar = new PortalAvailabilityCalendar(
                Availabilities,
                UnAvailabilities,
                Instructor,
                Instructor.CurrentDate,
                true
              )

              return (
                <>
                  <InstructorScheduler
                    loading={loading}
                    Instructor={Instructor}
                    AvailabilityCalendar={AvailabilityCalendar}
                    // refetch={refetch}
                    refetch={(fromDate, endDate) => {
                      console.log('(Instructor avilability) Refetch called with:', { fromDate, endDate })
                      return refetch(fromDate, endDate)
                    }}
                    isAdmin
                  />

                  <FetchFail error={error} />
                </>
              )
            }}
          </QueryPageData>
        )}

        <Spacer size="lg" />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateUserProfile: bindActionCreators(fetchProfileSuccess, dispatch),
})

export default connect(null, mapDispatchToProps)(injectIntl(withApollo(InstructorAvailability)))
